module.exports = __webpack_public_path__ + "media/line01.079bbbb6.webm";